import React, { useEffect, useState } from "react";
import { Button, CircularProgress, FormGroup, Typography } from "@mui/material";
import { useParams, useSearchParams } from "react-router-dom";
import * as yup from "yup";
import { useFormik } from "formik";

import { useOrderDetail } from "../../store/orderDetail";
import { useOrganization } from "../../store/organization";

import TextField from "../../components/TextField";
import {sendDetails} from "../../store/api";

const EnterDetail = (props) => {
  const params = useParams();
  const [searchParams] = useSearchParams();

  const {zip, zipInformation, getZipInformation} = useOrderDetail();
  const client = searchParams.get("client")?.toLowerCase();
  const {data: organizationData} = useOrganization(
    (state) => state.organization
  );

  useEffect(() => {
    window.analytics.track("Register Interest - Visited", {
      url: window.location.href,
      referrer: document.referrer,
      searchParams: searchParams,
      params: params,
      category: params.category,
      group: params.group,
      client: client,
      zip: zip,
    });
    // return () => {
    //   second;
    // };
  }, []);

  const formik = useFormik({
    initialValues: {
      zip: zip || "",
      email: "",
    },
    onSubmit: async (values) => {
      const response = await sendDetails({
        zipPostal: values.zip,
        email: values.email,
        externalProductId: `${params.category}-${params.group}`,
        organizationId: organizationData.organizationId,
      });

      if (!response.isError) {
        if (response.urlToRent) {
          window.location.assign(response.urlToRent);
        } else {
          // only for development
          alert("Unknown Redirection URL");
        }
      }
    },
    validationSchema: yup.object({
      zip: yup
        .string()
        .matches(/^[0-9]{5}$/, "Zip code must have 5 digits")
        .required("Required field. Please add a zip code."),
      email: yup.string().email().required("Email is required"),
    }),
  });

  return (
    <div className="unserviced-zip tw-flex tw-flex-col tw-justify-center tw-pt-8 tw-px-6">
      <Typography
        variant="p"
        className="tw-pt-5 tw-pb-5 tw-text-center tw-whitespace-pre-wrap tw-text-sm"
      >
        Enter you ZIP code and E-mail to proceed to Home Depot reservations.
      </Typography>

      <form onSubmit={formik.handleSubmit}>
        <FormGroup sx={{ marginBottom: "15px" }}>
          <TextField
            id="zip"
            label="Your ZIP code"
            variant="standard"
            name="zip"
            value={formik.values.zip}
            helperText={formik.touched.zip && formik.errors.zip}
            error={formik.touched.zip && Boolean(formik.errors.zip)}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
        </FormGroup>

        <FormGroup>
          <TextField
            id="email"
            label="Your E-mail"
            variant="standard"
            name="email"
            value={formik.values.email}
            helperText={formik.touched.email && formik.errors.email}
            error={formik.touched.email && Boolean(formik.errors.email)}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
        </FormGroup>

        <Button
          fullWidth={true}
          variant="contained"
          type="submit"
          style={{
            backgroundColor: "#333",
            height: "50px",
            marginTop: "40px",
            marginBottom: "50px",
          }}
        >
          {zipInformation.isLoading ? (
            <CircularProgress size={25} color="inherit" />
          ) : (
            "Continue"
          )}
        </Button>

      </form>
    </div>
  );
};

export default EnterDetail;
